export default class OrderStatusModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.name = data.name ?? '';
			if (data.subStatuses?.length) {
				this.subStatuses = data.subStatuses.map((statusRaw: any) => new OrderStatusModel(statusRaw));
			}		
		}
	}

	id = 0;	
	name = '';
	subStatuses: Array<OrderStatusModel> | null = null;
}